// extracted by mini-css-extract-plugin
module.exports = {"header__cell":"header__cell-4kpIr","fareGroup__name":"fareGroup__name-1wcUA","header__icon":"header__icon-3lFDX","travelTime":"travelTime-32QdP","arrowIcon":"arrowIcon-3BXtT"};